import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscaConfiguracaoImportacaoVendaModel } from "../models/configuracaoImportacaoVenda/buscaConfiguracaoImportacaoVendaModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarConfiguracaoImportacaoVenda, setModalDeletarConfiguracaoImportacaoVenda } from "../redux/slices/configuracaoImportacaoVenda/configuracaoImportacaoVendaSlice";

export const cadastrarConfiguracaoImportacaoVenda = createAsyncThunk("/ConfiguracaoImportacaoVenda/CadastrarConfiguracaoImportacaoVenda", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ConfiguracaoImportacaoVenda/CadastrarConfiguracaoImportacaoVenda/", payload.value);
    toastSucess("Configuração cadastrado com sucesso");
    dispatch(setModalCadastrarConfiguracaoImportacaoVenda(false));
    dispatch(setLoading(false));

    dispatch(listarConfiguracaoImportacaoVenda(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const listarConfiguracaoImportacaoVenda = createAsyncThunk("/ConfiguracaoImportacaoVenda/BuscarConfiguracaoImportacaoVenda", async (args: BuscaConfiguracaoImportacaoVendaModel) => {
  try {
    const data = await api.get("/ConfiguracaoImportacaoVenda/BuscarConfiguracaoImportacaoVenda", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarConfiguracaoImportacaoVenda = createAsyncThunk("/ConfiguracaoImportacaoVenda/AtualizarConfiguracaoImportacaoVenda", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/ConfiguracaoImportacaoVenda/AtualizarConfiguracaoImportacaoVenda/", payload.value);
    toastSucess("Configuração atualizada com sucesso");
    dispatch(setModalCadastrarConfiguracaoImportacaoVenda(false));
    dispatch(setLoading(false));

    dispatch(listarConfiguracaoImportacaoVenda(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarConfiguracaoImportacaoVenda = createAsyncThunk("/ConfiguracaoImportacaoVenda/DeletarConfiguracaoImportacaoVenda", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/ConfiguracaoImportacaoVenda/DeletarConfiguracaoImportacaoVenda/", { params: { id: payload.value } });
    toastSucess("Configuração removida com sucesso");
    dispatch(setModalDeletarConfiguracaoImportacaoVenda(false));
    dispatch(setLoading(false));

    dispatch(listarConfiguracaoImportacaoVenda(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
